import { Box, Typography, styled, IconButton } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const AppointmentCard = styled(Box)({
  border: `1px solid ${colors.border.light}`,
  borderRadius: "12px",
  padding: "24px",
  marginBottom: "16px",
  backgroundColor: colors.background.default,
});

export const AppointmentHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const AppointmentTitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const AppointmentTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.action,
  fontFamily: "Sora",
});

export const AppointmentBadge = styled(Box)({
  backgroundColor: colors.background.darkBlue,
  color: "#FFFFFF",
  padding: "4px 12px",
  borderRadius: "4px",
  fontSize: "12px",
  fontWeight: 600,
  fontFamily: "Sora",
});

export const AppointmentSubtitle = styled(Typography)({
  fontSize: "14px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
  marginTop: "4px",
  marginBottom: "16px",
});

export const AppointmentActions = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

export const CollapseButton = styled(IconButton)({
  padding: "8px",
  color: colors.text.secondary,
  "&:hover": {
    backgroundColor: "transparent",
  },
});

export const ActionButton = styled(IconButton)({
  padding: "8px",
  "&:hover": {
    backgroundColor: "transparent",
  },
});

export const DragHandle = styled(Box)({
  cursor: "grab",
  padding: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "4px",
  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: colors.background.lightBlue,
  },
  "&:active": {
    cursor: "grabbing",
    backgroundColor: colors.background.lightBlue,
  },
});

export const AppointmentContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const FieldRow = styled(Box)({
  display: "flex",
  gap: "16px",
});

export const FieldHalf = styled(Box)({
  flex: 1,
});

export const FieldQuarter = styled(Box)({
  flex: 0.5,
});

export const ProceduresSection = styled(Box)({
  marginTop: "8px",
});

export const ProcedureCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isDragging" && prop !== "isDragOver",
})<{
  isDragging?: boolean;
  isDragOver?: boolean;
}>(({ isDragging, isDragOver }) => ({
  borderRadius: isDragging ? "12px" : "none",
  marginBottom: "16px",
  backgroundColor: isDragOver ? colors.background.lightBlue : "transparent",
  opacity: isDragging ? 0.5 : 1,
  boxShadow: isDragging ? "0 4px 12px rgba(0,0,0,0.15)" : "none",
  transition:
    "border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease",
  "&:last-of-type": {
    marginBottom: "0",
  },
  "&:not(:first-of-type)": {
    borderTop: isDragging ? "none" : `1px solid ${colors.border.medium}`,
    paddingTop: "16px",
  },
}));

export const ProcedureHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "16px",
});

export const ProcedureTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  color: colors.text.link,
  fontFamily: "Sora",
});

export const ProcedureActions = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px",
});

export const ProcedureContent = styled(Box)({
  display: "flex",
  gap: "24px",
});

export const ProcedureLeftColumn = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const ProcedureRightColumn = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const ProcedureFieldsRow = styled(Box)({
  display: "flex",
  gap: "16px",
});

export const AddProcedureButton = styled(Box)({
  marginTop: "16px",
});
